/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

exports.__esModule = true;
exports.newGUID = newGUID;
/**
 * @file guid.js
 *
 * Unique ID for an element or function
 * @type {Number}
 * @private
 */
var _guid = 1;

/**
 * Get the next unique ID
 *
 * @return {String}
 * @function newGUID
 */
function newGUID() {
  return _guid++;
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/video.js/es5/utils/guid.js
// module id = 125
// module chunks = 0